// extracted by mini-css-extract-plugin
module.exports = {"price":"price-37z-y","button":"button-Gy5-B","seats":"seats-3CAgM"};